import styled from 'styled-components';

export const Wrapper = styled.div``;

export const BarWrapper = styled.div<{ isOpen: boolean }>`
  margin-bottom: ${({ isOpen }) => (isOpen ? '0' : '3px')};
`;

export const Content = styled.div``;
